import { createFileRoute, Link } from "@tanstack/react-router";
import { BookOpen, ClipboardList, LineChart, Users } from "lucide-react";

export const Route = createFileRoute("/lexpractiq/for-universities")({
  head: () => ({
    meta: [
      { title: "For Universities & Lecturers | SA LexPractiq" },
      { name: "description", content: "Assign realistic legal simulations to your class, monitor progress and standardise practical assessment." },
      { property: "og:title", content: "For Universities — SA LexPractiq" },
      { property: "og:description", content: "Experiential learning for LLB and BCom Law students at scale." },
    ],
  }),
  component: ForUniversitiesPage,
});

function ForUniversitiesPage() {
  return (
    <div className="lxp-container" style={{ padding: "3rem 1.25rem", maxWidth: 1000 }}>
      <span className="lxp-badge">For Universities &amp; Lecturers</span>
      <h1 style={{ fontSize: "clamp(1.8rem, 4vw, 2.6rem)", margin: "0.5rem 0 1rem", letterSpacing: "-0.02em" }}>
        Practical training that fits inside your <span style={{ color: "var(--lxp-accent)" }}>LLB curriculum</span>
      </h1>
      <p className="lxp-muted" style={{ fontSize: "1.05rem", lineHeight: 1.65, marginBottom: "2rem", maxWidth: 720 }}>
        Create a class, assign a simulation, and watch every student produce real legal work — with AI-scored rubrics and
        supervisor-style feedback delivered automatically.
      </p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "1rem", marginBottom: "2rem" }}>
        {[
          { icon: <ClipboardList size={22} />, t: "Assign & track", d: "Set due dates, monitor submissions and grade with AI-generated rubric scores." },
          { icon: <BookOpen size={22} />, t: "Curriculum-mapped", d: "Simulations aligned to Labour, Commercial, Constitutional and Compliance modules." },
          { icon: <LineChart size={22} />, t: "Cohort analytics", d: "See where the class is strong and weak across five competencies." },
          { icon: <Users size={22} />, t: "Bring your own scenarios", d: "Coming soon — publish institution-specific simulations under your brand." },
        ].map((f) => (
          <div key={f.t} className="lxp-card">
            <div style={{
              width: 42, height: 42, borderRadius: 10, background: "var(--lxp-accent-glow)",
              color: "var(--lxp-accent)", display: "grid", placeItems: "center", marginBottom: "0.75rem",
            }}>{f.icon}</div>
            <h3 style={{ margin: "0 0 0.4rem", fontSize: "1.05rem" }}>{f.t}</h3>
            <p className="lxp-muted" style={{ margin: 0, fontSize: "0.9rem" }}>{f.d}</p>
          </div>
        ))}
      </div>

      <div className="lxp-card" style={{ textAlign: "center", padding: "2rem" }}>
        <h2 style={{ margin: "0 0 0.5rem" }}>Set up your class</h2>
        <p className="lxp-muted" style={{ margin: "0 0 1.25rem" }}>Sign in and request the University role to create classes and assign simulations.</p>
        <Link to="/auth" search={{ portal: "lxp", redirect: "/lexpractiq/dashboard", mode: "signup" } as any} className="lxp-btn">Sign in / create account</Link>
      </div>
    </div>
  );
}
